module.exports = __webpack_public_path__ + "media/images/icon__arrow-left@2x-b1786e984cb903110bb32c86dc4b7437.png";